<div class="modal-header" *ngIf="isModal">
  <h5 class="modal-title">
    <span *ngIf="approvalStatus == 1">Pending Approval Requests</span>
    <span *ngIf="approvalStatus == 2">Pending Final Approval</span>
    <span *ngIf="approvalStatus == 3">Approved Requests</span>
    <span *ngIf="jsnName"> - {{ jsnName }}</span>
  </h5>
  <span class="fa fa-close" aria-label="Close" (click)="activeModal.close()"></span>
</div>

<div [ngClass]="isModal ? 'modal-body' : 'p-4'">
  <div *ngIf="approvalStatus <= 3" class="row d-print-none">
    <div class="col font-medium">
      <div class="row">
        <span *ngIf="!jsnId" class="col-9 d-flex min-h-70">
          <table *ngIf="departments && departments.length">
            <tr>

              <td><b>Department</b></td>
              <td *ngIf="
                selectedDepartment &&
                selectedDepartment != '00000000-0000-0000-0000-000000000000'
              ">
                Room
              </td>
              <td></td>
            </tr>
            <tr>
              <!-- department -->
              <td>
                <select #departmentselect class="clean-select" [(ngModel)]="selectedDepartment"
                  (change)="getAllRooms(departmentselect.value)">
                  <option [value]="emptyGuid">All</option>
                  <option *ngFor="let department of departments" [value]="department.id">
                    {{ department.departmentname }}
                  </option>
                </select>
              </td>
              <td *ngIf="selectedDepartment && selectedDepartment != emptyGuid">
                <select #roomselect class="clean-select" [(ngModel)]="selectedRoom"
                  (change)="getRequests(roomselect.value)">
                  <option [value]="emptyGuid">All</option>
                  <option *ngFor="let room of rooms" [value]="room.id">
                    {{ room.name }} ({{
                    isRoomTypical ? room.code : room.roomname
                    }})
                  </option>
                </select>
              </td>
              <td>
                <span class="d-flex align-items-center">
                  <i (click)="getApprovalRequests()" ngbTooltip="Refresh" class="fa-solid fa-arrows-rotate mr-2"
                    style="font-size: 28px;"></i>
                  <ng-template *ngTemplateOutlet="exportToExcel"></ng-template>
                </span>
              </td>
            </tr>
          </table>
          <ng-template *ngTemplateOutlet="secondaryActions"></ng-template>
        </span>
        <div class="search col-3 d-flex align-items-end justify-content-end">
          <ng-template *ngTemplateOutlet="search"></ng-template>
        </div>
      </div>



      <div class="row" *ngIf="selectedRequests.length && approvalStatus < 3">
        <!-- search -->
        <div class="col-8">
          <ng-template *ngTemplateOutlet="primaryActions"></ng-template>
        </div>
        <!-- <div class="search col-4 d-flex align-items-end justify-content-end mt-4">
          <ng-template *ngTemplateOutlet="search"></ng-template>
        </div> -->
      </div>


    </div>
  </div>
  <div class="auth-message mt-1" *ngIf="approvalStatus < 3 && showProjectApproval && !enableActions">
    You are not authorized to approve these records. Please contact your administrator if you require approval access.
  </div>
  <!-- NEW TABLE START -->
  <div class="table-wrapper mt-3">
    <div class="content-wrapper">
      <div class="table-div">
        <table class="content-table w-100">
          <tbody>
            <tr>
              <!-- <th class="text-center" width="5%">Info</th> -->
              <th
                *ngIf="(approvalStatus < 3 && ((showProjectApproval && enableActions) || !showProjectApproval)) || approvalStatus != 2"
                class="text-center" width="5%">
                <input [ngClass]="{'disabled-control':!canEdit}" [(ngModel)]="allSelected" (change)="selectAll($event)"
                  class="big-checkbox" type="checkbox" />
              </th>
              <th width="8%"
                *ngIf="approvalStatus < 3 && ((showProjectApproval && enableActions) || !showProjectApproval)">Actions
              </th>
              <th width="15%">Change Type</th>
              <!-- <th width="8%">Field</th> -->
              <th width="8%">JSN#</th>
              <th *ngIf="sessionId">Project</th>
              <th *ngIf="sessionId">Department</th>
              <th>Room</th>
              <th width="5%">Current</th>
              <th width="5%">Requested</th>
              <th>Nomenclature</th>
              <th>Description of change</th>
              <th width="8%">Estimated Cost</th>
            </tr>
            <ng-container *ngIf="approvalList.value.length; else noapprovaldata" [formGroup]="approvalForm">
              <tr formArrayName="approvalList" *ngFor="
                let content of approvalForm.get('approvalList')['controls'];
                let i = index
              ">
                <!-- <td class="text-center">
                              <span tooltipClass="my-custom-class" [ngbTooltip]="tipContent" class="fa fa-info-circle"></span>
                          </td> -->
                <td
                  *ngIf="(approvalStatus < 3 && ((showProjectApproval && enableActions) || !showProjectApproval)) || approvalStatus != 2"
                  [formGroupName]="i">
                  <input class="big-checkbox" formControlName="isSelected" type="checkbox" name="" id=""
                    [ngClass]="{'disabled-control':!canEdit}" />
                </td>
                <td [formGroupName]="i"
                  *ngIf="approvalStatus < 3 && ((showProjectApproval && enableActions) || !showProjectApproval)">
                  <span class="d-flex justify-content-center row-actions">
                    <button [ngClass]="{'disabled-control':!canEdit}" (click)="
                      confirmRequest(
                        [approvalForm.get('approvalList')['controls'][i].value],
                        actionType.APPROVE
                      )
                      " ngbTooltip="Approve">
                      <span class="fa fa-check"></span>
                    </button>
                    <button [ngClass]="{'disabled-control':!canEdit}" (click)="
                      openDenyDialog(
                        [approvalForm.get('approvalList')['controls'][i].value],
                        rejectdialog
                      )
                    " class="ml-2" ngbTooltip="Reject">
                      <span class="fa fa-close"></span>
                    </button>
                  </span>
                </td>
                <td [formGroupName]="i">
                  {{
                  approvalList.value[i]?.changedfield
                  ? approvalList.value[i]?.changedfield
                  : approvalList.value[i]?.changetype
                  }}
                </td>
                <!-- <td [formGroupName]="i">
                              <span *ngIf="approvalList.value[i]?.changedfield; else nochangedfield">{{approvalList.value[i]?.changedfield}}</span>
                          </td> -->
                <td [formGroupName]="i">
                  {{ approvalList.value[i]?.jsn }}
                </td>
                <td *ngIf="sessionId" [formGroupName]="i">
                  {{ approvalList.value[i]?.project || "-" }}
                </td>
                <td *ngIf="sessionId" [formGroupName]="i">
                  {{ approvalList.value[i]?.department || "-" }}
                </td>
                <td [formGroupName]="i">
                  {{ approvalList.value[i]?.room || "-" }}
                </td>
                <td [formGroupName]="i" class="url-cell">
                  {{ approvalList.value[i]?.currentvalue || "-" }}
                </td>
                <td [formGroupName]="i" class="url-cell">
                  {{ approvalList.value[i]?.requestedvalue || "-" }}
                </td>
                <td style="word-break: break-word" [formGroupName]="i">
                  {{ approvalList.value[i]?.nomenclature || "N/A" }}
                </td>
                <td [formGroupName]="i">
                  <span *ngIf="
                    sessionId || approvalStatus > 2;
                    else editChangeDescriptionTemplate
                  ">
                    {{ approvalList.value[i]?.changedescription || "N/A" }}
                  </span>
                  <ng-template #editChangeDescriptionTemplate>
                    <span *ngIf="approvalStatus <= 2">
                      <textarea rows="3" (blur)="updateApprovalRequest(approvalList.value[i]?.id)" class="clean-input"
                        type="text" formControlName="changedescription" placeholder="Change Description"></textarea>
                    </span>
                  </ng-template>
                </td>
                <td [formGroupName]="i">
                  <span *ngIf="
                    sessionId || approvalStatus > 2;
                    else editEstimatedCostTemplate
                  ">
                    {{ approvalList.value[i]?.estimatedcost || "$0" }}
                  </span>
                  <ng-template #editEstimatedCostTemplate>
                    <span *ngIf="approvalStatus <= 2">
                      <input (blur)="updateApprovalRequest(approvalList.value[i]?.id)" class="clean-input" type="number"
                        formControlName="estimatedcost" placeholder="Cost" />
                    </span>
                  </ng-template>
                </td>
              </tr>
            </ng-container>
            <ng-template #noapprovaldata>
              <tr>
                <td class="p-4 text-center" colspan="10">No Data</td>
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>
      <div class="text-center dark-grey-bg d-flex align-items-center justify-content-end pr-3">
        <div *ngIf="approvalStatus < 3; else approvedRequestFooter">
          <div *ngIf="enableActions ; else notEnableActions">

            Total
            Cost: ${{
            getTotalEstimation() }}

          </div>
          <ng-template #notEnableActions>

            Total
            Cost: ${{
            getTotalEstimation() }}

          </ng-template>
        </div>
        <ng-template #approvedRequestFooter>

          Total
          Cost: ${{
          getTotalEstimation() }}

        </ng-template>
      </div>
      <div *ngIf="totalCount" class="pagination-footer">
        <div class="pagination-info">Showing {{startIndex}} to {{endIndex}} of {{totalCount}} records.</div>
        <div class="pagination-controls">
          <span class="pagination-label">Items per page:</span>
          <select class="page-size-select" [(ngModel)]="pageSize" (change)="onPageSizeChange()">
            <option *ngFor="let size of pageSizes" [ngValue]="size">{{size}}</option>
          </select>
          <ngb-pagination (pageChange)="onPageChange($event)" [rotate]="true" [boundaryLinks]="true"
            *ngIf="totalCount > pageSize" class="d-flex mb-0" [collectionSize]="totalCount"
            [(page)]="page" [maxSize]="5" [pageSize]="pageSize">
          </ngb-pagination>
        </div>
      </div>
    </div>
  </div>
  <!-- NEW TABLE END -->

  <ng-template #rejectdialog let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">DENY APPROVAL REQUEST</h4>
      <span class="fa fa-close" aria-label="Close" (click)="modal.close()"></span>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label for="exampleFormControlTextarea1">Please specify deny reason</label>
        <textarea [(ngModel)]="denyReason" placeholder="Enter reason here" class="form-control"
          id="exampleFormControlTextarea1" rows="3"></textarea>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" [disabled]="!denyReason" [ngClass]="{ 'disabled-control': !denyReason }"
        class="button button-action-icon" (click)="modal.close(denyReason)">
        DENY
      </button>
    </div>
  </ng-template>

  <ng-template #primaryActions>
    <span class="d-flex w-100 mt-4 align-items-end">
      <div *ngIf="allSelected && totalCount> pageSize">
        <div class="mb-0" *ngIf="!totalSelected">
          All approvals on this page are selected &nbsp; &nbsp; <br>
          <div class="cursor-pointer" (click)="selectTotal()">
            Select all
            {{totalCount}}
            pending approvals
          </div>
        </div>
        <div class="mb-0" *ngIf="totalSelected">
          All {{totalCount}} approvals on all page are selected &nbsp; &nbsp; <br>
        </div>
      </div>
      <div *ngIf="approvalStatus < 3 && ((showProjectApproval && enableActions) || !showProjectApproval)"
        (click)="confirmRequest(selectedRequests, actionType.APPROVE)" class="button button-action-icon mr-2">
        <span>Approve Selected</span>
      </div>
      <div *ngIf="approvalStatus < 3 && ((showProjectApproval && enableActions) || !showProjectApproval)"
        (click)="openDenyDialog(selectedRequests, rejectdialog)" class="button button-action-icon">
        <span>Deny Selected</span>
      </div>
    </span>
  </ng-template>
  <ng-template #search>
    <span class="d-flex w-100 mt-4 align-items-end justify-content-end">
      <concourse-search-bar [allowDebounce]="true" (onSearchValue)="searchResults($event)">
      </concourse-search-bar>
    </span>
  </ng-template>
  <ng-template #secondaryActions>
    <div *ngIf="approvalStatus < 2 && sessionId == null" (click)="shareRequest()" class="ml-2 action-container">
      <img [ngClass]="{
          'disabled-icon':
            approvalList.value.length < 1 || selectedRequests.length < 1
        }" ngbTooltip="Share" width="44" height="44" src="assets/images/share-icon.png" />
    </div>
  </ng-template>
  <ng-template #exportToExcel>

    <img [ngClass]="{ 'disabled-icon': approvalList.value.length < 1 }" (click)="approvalList.value.length &&
          openExportCSVDialog(approvalList.value, approvalStatus)
      " ngbTooltip="Export All" width="44" height="44" src="assets/images/excel-icon.png" />
  </ng-template>
  <ng-template #nochangedfield>
    <span class="d-flex align-items-center justify-content-center">-</span>
  </ng-template>
  <ng-template #tipContent>
    <div class="text-left">
      <small class="text-muted">PROJECT</small>
      <h4>Lubbock</h4>
    </div>
    <div>
      <small class="text-muted">ROOM</small>
      <h4>350A</h4>
    </div>
  </ng-template>
  <ng-template #nochangedfield>
    <span class="d-flex align-items-center justify-content-center">-</span>
  </ng-template>

</div>

<ng-template #csvDownloadDialog>
  <div class="modal-header">
    <h5 class="modal-title w-100">
      <!-- <div class="alert-icon d-flex justify-content-center mb-4">
        <img src="/assets/images/alert.png" height="70px" width="auto" />
      </div> -->
      <p class="text d-block m-0">Download CSV</p>
    </h5>
    <span class="fa fa-close" aria-label="Close" (click)="csvDownloadDialogModal.close(0)"></span>
  </div>
  <div class="modal-body w-100 d-flex flex-column align-items-center">
    <div class="text-center">
      <p class="text">Please select an option to export records:</p>
    </div>

    <div class="">

      <div>
        <input type="radio" id="0" name="exportcsv" [value]="0" checked [(ngModel)]="selectedCsvOption" />
        <label for="0">All records of this page</label>
      </div>

      <div>
        <input [disabled]="totalCount <= pageSize" type="radio" id="1" name="exportcsv" [value]="1"
          [(ngModel)]="selectedCsvOption" />
        <label for="1">All records of this project</label>
      </div>

      <div>
        <input [disabled]="!selectedRequests.length" type="radio" id="2" name="exportcsv" [value]="2"
          [(ngModel)]="selectedCsvOption" />
        <label for="2">Only selected records</label>
      </div>
    </div>

  </div>
  <div class="modal-footer w-100 d-flex flex-column">
    <div class="w-100 action-buttons d-flex align-items-center justify-content-end gap-1">
      <button type="button" class="btn btn-primary" (click)="csvDownloadDialogModal.close(0)">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="csvDownloadDialogModal.close(1)">Download</button>
    </div>
  </div>
</ng-template>